//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    IMPORT_ACCOUNT_EXCEPTION_SEARCH_DETAILS_REQUEST,
    IMPORT_ACCOUNT_EXCEPTION_GET_DETAILS_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    exceptionImportGetDetailsResult,
    exceptionImportSearchDetailsResult,
} from 'Redux/actions';


function* searchCompanyMigrationExceptions({ payload }) {
    const { targetAccountId, sourceEntityName, message } = payload
    
    try {
        let QUERY = `
            query searchCompanyMigrationExceptions ($conditions: [CompanyMigrationExceptionSearchInput], $sort: [CompanyMigrationExceptionSortInput], $limit: Int, $offset: Int) {
                result: searchCompanyMigrationExceptions (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        sourceEntityId
                        sourceEntityName
                        message
                        targetAccountId
                        createdOn
                    }
                    total
                }
            }
        `;

        let conditions = [
            {
                fields: ["targetAccountId"],
                terms: [targetAccountId],
                exact: true
            },
            {
                fields: ["sourceEntityName"],
                terms: [sourceEntityName || ''],
                exact: false
            }
        ]

        if(message){
            conditions.push({
                fields: ["message"],
                terms: [message],
                exact: false
            })
        }

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions,
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            const { items } = data.result
            yield put(exceptionImportSearchDetailsResult(items))
        }
    } catch (exc) {
        yield put(exceptionImportSearchDetailsResult([]))
        ExceptionManager(exc, 'Modules/importAccount/views/main/.components/exceptionDetails/redux/saga', 'searchCompanyMigrationExceptions');
    }
}

function* getCompanyMigrationException({ payload }) {
    try {
        let QUERY = `
            query getCompanyMigrationException ($id: Int!) {
                result: getCompanyMigrationException (id: $id) {
                    id
                    record
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(exceptionImportGetDetailsResult(data.result))
        }

    } catch (exc) {
        yield put(exceptionImportGetDetailsResult())
        ExceptionManager(exc, 'Modules/importAccount/views/main/.components/exceptionDetails/redux/saga', 'getCompanyMigrationException');
    }
}

function* watchCatalogRequests() {
    yield takeEvery(IMPORT_ACCOUNT_EXCEPTION_SEARCH_DETAILS_REQUEST, searchCompanyMigrationExceptions);
    yield takeEvery(IMPORT_ACCOUNT_EXCEPTION_GET_DETAILS_REQUEST, getCompanyMigrationException);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}